import { render, staticRenderFns } from "./MainLibraryComponent.vue?vue&type=template&id=50a23476&scoped=true"
import script from "./MainLibraryComponent.vue?vue&type=script&lang=js"
export * from "./MainLibraryComponent.vue?vue&type=script&lang=js"
import style0 from "./MainLibraryComponent.vue?vue&type=style&index=0&id=50a23476&prod&scoped=true&lang=css"
import style1 from "./MainLibraryComponent.vue?vue&type=style&index=1&id=50a23476&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a23476",
  null
  
)

export default component.exports